import React, { useEffect, useState } from 'react';

interface ToggleButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  text?: string;
  className?: string;
  initialOpen?: boolean;
  onToggle?: (isOpen: boolean) => void;
}

export default function ToggleButton({
  className,
  text,
  initialOpen = false,
  onToggle,
  ...props
}: ToggleButtonProps) {
  const [isOpen, setIsOpen] = useState(initialOpen);

  const handleClick = () => {
    const newState = !isOpen;
    setIsOpen(newState);
    if (onToggle) {
      onToggle(newState);
    }
  };

  useEffect(() => {
    setIsOpen(initialOpen);
  }, [initialOpen]);

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`flex items-center gap-2 bg-interit ${className}`}
      {...props}
    >
      <span className="text-xs text-gray-500 w-3 text-center">{isOpen ? '▼' : '▶'}</span>
      <span className="font-medium text-sm">{text || ''}</span>
    </button>
  );
}
